var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.$t('dictionary.tap_service')}}),_c('page-body',[_c('tap-service-list',{attrs:{"id":_vm.listId,"filterParams":_vm.filterParams}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }